import Image from 'next/image';
import { FC } from 'react';
import SliderNavigation from '~/components/embla-slider/navigation';
import Media from '~/data/strapi/types/defaults/media';
import alt from '~/utils/default-alt';
import getDataPath from '~/utils/get-data-path';

import styles from './styles.module.css';

interface Props {
  image: Media;
  onNext?: () => void;
  onPrev?: () => void;
  hrefNext?: string;
  hrefPrev?: string;
  hideNavigation?: boolean;
}

const ProjectDescriptionImage: FC<Props> = ({ image, onNext, onPrev, hrefNext, hrefPrev, hideNavigation }) => {
  return (
    <div className={styles.img}>
      <Image src={getDataPath(image.url)} alt={alt(image.alternativeText)} fill />

      {!hideNavigation && (
        <SliderNavigation
          onNext={onNext}
          onPrev={onPrev}
          hrefNext={hrefNext}
          hrefPrev={hrefPrev}
          containerClassName={styles.navigation}
        />
      )}
    </div>
  );
};

export default ProjectDescriptionImage;
